export default "__VITE_ASSET__58b23226__"